import { useColorConfig } from '../utils/colorConfig';

const useLoginStyles = () => {
    const colors = useColorConfig();
    const loginColors = colors?.components?.loginPage || {};
    const gradients = colors?.gradients || {};

    return {
        container: {
            minHeight: '100vh',
            minWidth: '100vw',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: loginColors.background || 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: 2,
        },
        card: {
            width: '100%',
            maxWidth: 450,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: 4,
            borderRadius: 3,
            backgroundColor: loginColors.cardBackground || '#ffffff',
            boxShadow: loginColors.cardShadow || '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
        },
        title: {
            color: loginColors.titleColor || '#111827',
            fontWeight: 700,
            mb: 1,
            textAlign: 'center',
        },
        subtitle: {
            color: loginColors.subtitleColor || '#6b7280',
            mb: 4,
            textAlign: 'center',
        },
        form: {
            width: '100%',
            mt: 1,
        },
        input: {
            mb: 2,
            '& .MuiOutlinedInput-root': {
                borderRadius: '30px',
                backgroundColor: loginColors.inputBackground || '#f9fafb',
                '& fieldset': {
                    borderColor: loginColors.inputBorder || '#e5e7eb',
                },
                '&:hover fieldset': {
                    borderColor: colors.palette?.primary || '#1976d2',
                },
                '&.Mui-focused fieldset': {
                    borderColor: loginColors.inputFocusBorder || colors.palette?.primary || '#1976d2',
                },
            },
        },
        iconColor: loginColors.iconColor || '#000000',
        button: {
            mt: 3,
            mb: 2,
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 2,
            background: gradients.primary ? `linear-gradient(to right, ${gradients.primary[0]}, ${gradients.primary[1]})` : (colors.palette?.primary || '#1976d2'),
            color: loginColors.buttonText || '#ffffff',
            boxShadow: loginColors.buttonShadow || '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            '&:hover': {
                boxShadow: loginColors.buttonHoverShadow || '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                filter: loginColors.buttonHoverFilter || 'brightness(1.1)',
            },
        }
    };
};

export default useLoginStyles;